import {
  getNotifications as getNotificationsRepository,
  confirmFollow as confirmFollowRepository,
  rejectFollow as rejectFollowRepository,
  getMessagesNotification as getMessagesNotificationRepository,
  getMessages as getMessagesRepository,
  getRedirectNotification as getRedirectNotificationRepository,
  seenMessageRepository,
  seenNotificationRepository,
} from "../repositories/NotificationsRepository";
import { getNotificationsMapper } from "../mappers/NotificationsMapper";
import { createRequestResourceCache } from "../utils/requestResourceCache";

// Notificaciones se refrescan también por SignalR. La caché de 3 segundos
// solo absorbe montajes/reintentos inmediatos; los eventos realtime usan
// `forceRefresh` para saltársela.
const notificationsRequestCache = createRequestResourceCache({ ttlMs: 3000 });
const messagesRequestCache = createRequestResourceCache({ ttlMs: 0 });

const buildNotificationsKey = (userId, filters = {}) =>
  [
    "notifications",
    String(userId ?? ""),
    filters.page ?? "",
    filters.pageSize ?? "",
    typeof filters.visto === "boolean" ? String(filters.visto) : "",
  ].join("|");

const buildMessagesKey = (userId, filters = {}) =>
  [
    "messages",
    String(userId ?? ""),
    filters.mostrarArchivados === true ? "archived" : "active",
    typeof filters.estatusMensaje === "number"
      ? String(filters.estatusMensaje)
      : "all",
  ].join("|");

export const getNotificationsService = async (userId, filters = {}) => {
  const { forceRefresh = false, ...requestFilters } = filters;
  const requestKey = buildNotificationsKey(userId, requestFilters);

  return notificationsRequestCache.read(
    requestKey,
    async () => {
      const notifications = await getNotificationsRepository(
        userId,
        requestFilters,
      );
      return getNotificationsMapper(notifications);
    },
    { force: forceRefresh === true },
  );
};

export const invalidateNotificationsCache = (userId) => {
  const prefix = `notifications|${String(userId ?? "")}|`;
  notificationsRequestCache.invalidateMatching((key) => key.startsWith(prefix));
};

export const confirmFollowService = async (userId) => {
  try {
    return await confirmFollowRepository(userId);
  } catch (error) {
    throw error;
  }
};

export const rejectFollowService = async (userId) => {
  try {
    return await rejectFollowRepository(userId);
  } catch (error) {
    throw error;
  }
};

export const getMessagesNotificationService = async (userId) => {
  try {
    return await getMessagesNotificationRepository(userId);
  } catch (error) {
    throw error;
  }
};

export const getMessagesService = async (userId, filters = {}) => {
  const requestKey = buildMessagesKey(userId, filters);

  return messagesRequestCache.read(
    requestKey,
    () => getMessagesRepository(userId, filters),
  );
};

export const redirectNotificationService = async (redirectNotification) => {
  try {
    return await getRedirectNotificationRepository(redirectNotification);
  } catch (error) {
    throw error;
  }
};

export const seenMessageService = async (payload) => {
  try {
    return await seenMessageRepository(payload);
  } catch (error) {
    throw error;
  }
};

export const seenNotificationService = async (payload) => {
  try {
    return await seenNotificationRepository(payload);
  } catch (error) {
    throw error;
  }
};
